import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SelectComponent, SelectOption } from '../select/select.component';

export type SortOption = SelectOption;

@Component({
  selector: 'app-sort-dropdown',
  imports: [SelectComponent],
  template: `
    <div class="sort-dropdown">
      <app-select
        id="sort-select"
        [label]="label()"
        [options]="options()"
        [value]="value()"
        [placeholder]="placeholder()"
        (valueChange)="valueChange.emit($event)"
      />
    </div>
  `,
  styleUrl: './sort-dropdown.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
})
export class SortDropdownComponent {
  options = input.required<SortOption[]>();
  value = input<string>('');
  placeholder = input<string>('Ordenar por');
  label = input<string>('');

  valueChange = output<string>();
}
